/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppState } from './AppState';
import {
    AppStateFromJSON,
    AppStateFromJSONTyped,
    AppStateToJSON,
} from './AppState';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { PayloadTypeConstants } from './PayloadTypeConstants';
import {
    PayloadTypeConstantsFromJSON,
    PayloadTypeConstantsFromJSONTyped,
    PayloadTypeConstantsToJSON,
} from './PayloadTypeConstants';

/**
 * 
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {PayloadTypeConstants}
     * @memberof SessionResponse
     */
    type: PayloadTypeConstants;
    /**
     * 
     * @type {Array<Message>}
     * @memberof SessionResponse
     */
    messages: Array<Message>;
    /**
     * 
     * @type {AppState}
     * @memberof SessionResponse
     */
    payload?: AppState;
}

/**
 * Check if a given object implements the SessionResponse interface.
 */
export function instanceOfSessionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function SessionResponseFromJSON(json: any): SessionResponse {
    return SessionResponseFromJSONTyped(json, false);
}

export function SessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PayloadTypeConstantsFromJSON(json['type']),
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : AppStateFromJSON(json['payload']),
    };
}

export function SessionResponseToJSON(value?: SessionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PayloadTypeConstantsToJSON(value.type),
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': AppStateToJSON(value.payload),
    };
}

